<template>
  <el-button
    :class="classP"
    :disabled="disabled"
    :loading="loading"
    :primary="primary"
    :sutartis="sutartis"
    :small="small"
    :x-small="xSmall"
    ><v-icon small>{{ icon }}</v-icon> <slot
  /></el-button>
</template>

<script>
export default {
  name: 'ElButtonIcon',
  props: {
    classP: String,
    icon: String,
    primary: Boolean,
    sutartis: Boolean,
    disabled: Boolean,
    loading: Boolean,
    small: Boolean,
    xSmall: Boolean,
  },
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/elementsTheme.scss';
</style>
